import React from 'react'

const CustomButton = ({ children, handalClick, className, outline, ...props }) => {
    return (
        <button {...props} className={`${outline ? 'btn btn-outline' : `btn btn-default ${className}`}`} onClick={() => handalClick && handalClick()}>{children}</button>
    )
}

export default CustomButton
